/* SPOOKY LANE — interacciones (prefijo sl-) */
(function () {
  if (window.__slIniciado) return;
  window.__slIniciado = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.sl-reveal:not(.sl-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('sl-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('sl-visible');
        e.target.querySelectorAll('[data-sl-count]').forEach(countUp);
        if (e.target.hasAttribute('data-sl-count')) countUp(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function countUp(el) {
    if (el.dataset.slDone) return;
    el.dataset.slDone = '1';
    var fin = parseFloat(el.getAttribute('data-sl-count')) || 0;
    if (reduce) { el.textContent = fin; return; }
    var dur = 1600, t0 = null;
    function paso(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      var v = fin * (1 - Math.pow(1 - p, 3));
      el.textContent = Math.round(v);
      if (p < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  }

  function initGaleria(root) {
    (root || document).querySelectorAll('[data-sl-galeria]').forEach(function (gal) {
      var main = gal.querySelector('[data-sl-main]');
      if (!main) return;
      gal.querySelectorAll('[data-sl-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          main.style.opacity = 0;
          setTimeout(function () {
            main.src = btn.getAttribute('data-src');
            main.srcset = btn.getAttribute('data-srcset') || '';
            main.alt = btn.getAttribute('data-alt') || '';
            main.style.opacity = 1;
          }, 180);
          gal.querySelectorAll('[data-sl-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
          btn.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  function initProducto(root) {
    (root || document).querySelectorAll('[data-sl-producto]').forEach(function (wrap) {
      var form = wrap.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var idInput = form.querySelector('input[name="id"]');
      var btn = form.querySelector('[data-sl-add]');
      var btnTxt = btn ? btn.getAttribute('data-txt') : '';
      var agotado = btn ? btn.getAttribute('data-agotado') : '';
      var precio = wrap.querySelector('[data-sl-precio]');
      var tachado = wrap.querySelector('[data-sl-tachado]');
      var dataEl = wrap.querySelector('[data-sl-variantes]');
      var variantes = dataEl ? JSON.parse(dataEl.textContent) : [];
      var fmt = wrap.getAttribute('data-money') || '{{amount_with_comma_separator}} €';

      function money(c) {
        var n = (c / 100).toFixed(2);
        var partes = n.split('.');
        var miles = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        var coma = miles + ',' + partes[1];
        var punto = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + partes[1];
        return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, coma)
                  .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, miles)
                  .replace(/\{\{\s*amount_no_decimals\s*\}\}/, partes[0])
                  .replace(/\{\{\s*amount\s*\}\}/, punto);
      }

      function actualizar() {
        var sel = [];
        wrap.querySelectorAll('[data-sl-opcion]').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          sel.push(c ? c.value : null);
        });
        if (!sel.length) return;
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        if (!v) {
          if (btn) { btn.disabled = true; btn.querySelector('span').textContent = agotado; }
          return;
        }
        idInput.value = v.id;
        if (precio) precio.textContent = money(v.price);
        if (tachado) {
          if (v.compare_at_price && v.compare_at_price > v.price) { tachado.textContent = money(v.compare_at_price); tachado.hidden = false; }
          else tachado.hidden = true;
        }
        if (btn) { btn.disabled = !v.available; btn.querySelector('span').textContent = v.available ? btnTxt : agotado; }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      wrap.querySelectorAll('[data-sl-opcion] input').forEach(function (i) { i.addEventListener('change', actualizar); });

      var qty = wrap.querySelector('[data-sl-qty]');
      if (qty) {
        wrap.querySelectorAll('[data-sl-qty-btn]').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = parseInt(qty.value, 10) || 1;
            n += parseInt(b.getAttribute('data-sl-qty-btn'), 10);
            qty.value = Math.max(1, n);
          });
        });
      }

      var sticky = document.querySelector('[data-sl-sticky-buy]');
      if (sticky && btn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var fuera = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
          sticky.classList.toggle('sl-show', fuera);
        }).observe(btn);
        var sb = sticky.querySelector('button');
        if (sb) sb.addEventListener('click', function () { if (!btn.disabled) btn.click(); });
      }
    });
  }

  function initFaq(root) {
    (root || document).querySelectorAll("[data-sl-faq]").forEach(function (lista) {
      var una = lista.hasAttribute("data-sl-faq-una");
      var items = lista.querySelectorAll("details");
      function cerrar(d) {
        var a = d.querySelector(".sl-faq__a");
        if (reduce || !a.animate) { d.open = false; return; }
        var anim = a.animate([{ height: a.offsetHeight + "px", opacity: 1 }, { height: "0px", opacity: 0 }], { duration: 320, easing: "cubic-bezier(0.22, 1, 0.36, 1)" });
        var hecho = false;
        function fin() { if (hecho) return; hecho = true; d.open = false; }
        anim.onfinish = fin;
        setTimeout(fin, 360);
      }
      function abrir(d) {
        d.open = true;
        var a = d.querySelector(".sl-faq__a");
        if (reduce || !a.animate) return;
        a.animate([{ height: "0px", opacity: 0 }, { height: a.offsetHeight + "px", opacity: 1 }], { duration: 420, easing: "cubic-bezier(0.22, 1, 0.36, 1)" });
      }
      items.forEach(function (d) {
        d.querySelector("summary").addEventListener("click", function (e) {
          e.preventDefault();
          if (d.open) { cerrar(d); return; }
          if (una) items.forEach(function (o) { if (o !== d && o.open) cerrar(o); });
          abrir(d);
        });
      });
    });
  }

  function objetivoHalloween() {
    var ahora = new Date();
    var y = ahora.getFullYear();
    var fin = new Date(y, 9, 31, 0, 0, 0);
    if (ahora > new Date(y, 10, 1, 0, 0, 0)) fin = new Date(y + 1, 9, 31, 0, 0, 0);
    return fin;
  }

  function initCuenta(root) {
    var fin = objetivoHalloween();
    var cajas = (root || document).querySelectorAll("[data-sl-cuenta]");
    var textos = (root || document).querySelectorAll("[data-sl-dias-texto]");
    if (!cajas.length && !textos.length) return;
    function pintar() {
      var ms = fin - new Date();
      var hoy = ms <= 0;
      if (ms < 0) ms = 0;
      var d = Math.floor(ms / 86400000), h = Math.floor(ms / 3600000) % 24, m = Math.floor(ms / 60000) % 60, s = Math.floor(ms / 1000) % 60;
      cajas.forEach(function (c) {
        var set = function (k, v) { var el = c.querySelector("[data-sl-" + k + "]"); if (el) el.textContent = String(v).padStart(2, "0"); };
        set("d", d); set("h", h); set("m", m); set("s", s);
      });
      textos.forEach(function (t) {
        var plantilla = hoy ? t.getAttribute("data-hoy") : t.getAttribute("data-plantilla");
        var fl = t.getAttribute("data-fecha-limite");
        if (!hoy && fl && t.getAttribute("data-plantilla-limite")) {
          var lim = new Date(fl + "T23:59:59");
          if (!isNaN(lim) && new Date() <= lim) plantilla = t.getAttribute("data-plantilla-limite");
        }
        t.innerHTML = (plantilla || "").replace("{dias}", "<strong>" + d + "</strong>");
      });
    }
    pintar();
    setInterval(pintar, 1000);
  }

  function initParallax(root) {
    var els = (root || document).querySelectorAll("[data-sl-parallax]");
    if (!els.length || reduce) return;
    var tick = false;
    function mover() {
      els.forEach(function (el) {
        var f = parseFloat(el.getAttribute("data-sl-parallax")) || 0.15;
        var r = el.parentElement.getBoundingClientRect();
        el.style.transform = "translateY(" + (-r.top * f) + "px)";
      });
      tick = false;
    }
    window.addEventListener("scroll", function () { if (!tick) { tick = true; requestAnimationFrame(mover); } }, { passive: true });
    mover();
  }

  function initDuoAdd(root) {
    (root || document).querySelectorAll("[data-sl-duo-add]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var ids = (btn.getAttribute("data-ids") || "").split(",").filter(Boolean);
        var err = btn.parentElement.querySelector("[data-sl-duo-error]");
        btn.disabled = true;
        fetch(btn.getAttribute("data-add-url"), {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; }) })
        }).then(function (r) {
          if (!r.ok) throw new Error("add");
          window.location.href = btn.getAttribute("data-carrito");
        }).catch(function () {
          btn.disabled = false;
          if (err) err.textContent = btn.getAttribute("data-error");
        });
      });
    });
  }

  function initHasta(root) {
    (root || document).querySelectorAll("[data-sl-hasta]").forEach(function (el) {
      var lim = new Date(el.getAttribute("data-sl-hasta") + "T23:59:59");
      if (isNaN(lim) || new Date() > lim) el.remove(); else el.hidden = false;
    });
  }

  function initEscena(root) {
    (root || document).querySelectorAll("[data-sl-escena]").forEach(function (esc) {
      if (esc.dataset.slOk) return; esc.dataset.slOk = "1";
      var fotos = esc.querySelectorAll(".sl-escena__foto"), puntos = esc.querySelectorAll(".sl-escena__puntos span");
      if (fotos.length < 2 || reduce) return;
      var dur = parseFloat(getComputedStyle(esc).getPropertyValue("--sl-dur")) || 5, i = 0;
      fotos.forEach(function (f) { var im = f.querySelector("img"); if (im) im.loading = "eager"; });
      setInterval(function () {
        fotos[i].classList.remove("sl-activa"); if (puntos[i]) puntos[i].classList.remove("sl-activa");
        i = (i + 1) % fotos.length;
        fotos[i].classList.add("sl-activa"); if (puntos[i]) puntos[i].classList.add("sl-activa");
      }, dur * 1000);
    });
  }

  function init(root) { initEscena(root); initHasta(root); initDuoAdd(root); initReveal(root); initGaleria(root); initProducto(root); initFaq(root); initCuenta(root); initParallax(root); }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
